
function Successfull    () {
    return (

    <div>
        <div class={"message"}>{"Heslo bolo zmenené úspešne,  odhláste  sa a zatvorte prehliadač."} </div>
    </div>


        )

}

export default Successfull